import { get, flow, toPairs, map, replace, find } from 'lodash/fp';
import { createStructuredSelector, createSelector } from 'reselect';
import { prepareOptions } from 'helpers/fieldOptions';

const getOptionsByMake = (state, props) =>
  get(['vehicle', 'subType', props.makeValue, 'result'], state);

const getSubTypeOptions = createSelector(
  get(['vehicle']),
  getOptionsByMake,
  (state, props) => props.makeValue,
  (state, props) => props.modelValue,
  (vehicle, subTypes, make, model) => {
    if (!model || !subTypes) {
      return [];
    }

    subTypes = get([model, 'subtypes'], subTypes);

    if (!subTypes) {
      return [];
    }

    const modelLabel = flow(
      get(['model', make, 'result']),
      find({ value: model }),
      get(['label']),
    )(vehicle);

    return flow(
      toPairs,
      map(([value, label]) => ({
        value,
        label: flow(replace(modelLabel, ''))(label),
      })),
      prepareOptions,
    )(subTypes);
  },
);

export default createStructuredSelector({
  options: getSubTypeOptions,
});
